<template>
   <button @click="clicked" :class="[ classes ]">
      <i v-if="type == 'loading' && isHidden" class='fas fa-spinner fa-pulse'></i>
      <i v-if="icon != ''" :class="icon"></i>
      <slot></slot>
   </button>
</template>

<script>
export default {
   data() {
      return {
         isHidden: false
      }
   },
   props: {
      color: { type: String, default: '' },
      colorStyle: { type: String, default: 'block'},
      size: { type: String, default: '' },
      long: { type: Boolean, default: false },
      icon: { type: String, default: '' },
      iconStyle: { type: String, default: null},
      type: { type: String, default: null },
      disabled: {type: Boolean, default: false},
      social: {type: String, default: ''}
   },
   computed: {
      classes () {
        // TODO: Ross - what is the reason for setting these constants instead of using this.user, this.color?
        // James - just a way of not having to write 'this.' on every line 
         const { color, colorStyle, size, disabled, social, long, iconStyle, type } = this

         const colorName = color != '' ? `--${color}` : '--primary'

         const extensions = {
            'outline': '-alt',
            'text'   : '-text'
         };
         const colorExt = extensions[colorStyle] || ''

         const typeStyle = {
            'submit': '--submit',
            'loading': '--loading js-button__loading',
            'search': '--search'
         }
         const typeClass = typeStyle[type] || ''

         const icon = {
            'right' : '-right',
            'left' : '-left',
            'round' : '-round',
            'icon' : ''
         }
         const iconClass = icon[iconStyle] || ''

         return [
            colorName ? [`button${colorName}${colorExt}`] : [null],
            size ? [`button--${size}`] : [null],
            long ? [`button--long`] : [null],
            iconStyle ? [`button--icon${iconClass}`] : [null],
            typeClass ? [`button${typeClass}`] : [null],
            disabled ? [`disabled`] : [null],
            social ? [`button--${social}`] : [null]
         ]
      },
   },
   methods: {
      clicked: function(e) {
         this.$emit('click', e);
         this.type === 'loading' ? this.isHidden = true : null
      }
   }
}
</script>

<style lang="scss" scoped>
@import '~/assets/root.scss';

@import '~/assets/SCSS/Base/00_functions.scss';
@import '~/assets/SCSS/Base/01_variables.scss';
@import '~/assets/SCSS/Base/02_mixins.scss';

@import '~/assets/SCSS/Elements/button.scss';
</style>
